/* Greenleaf — search results: pieces that contain EVERY typed word come first.
 * 30 Sep 2026, Andrew: yes to "pieces that match every word come first, the way
 * the search box already does".
 *
 * WHY. Shopify's storefront search matches loosely, by meaning. "diamond necklace"
 * returns 285 results for a case that holds 84 necklaces, because it takes pieces
 * that match either word, and it ignores AND and + (measured that day: "diamond
 * AND necklace" gave 346). No theme or Search & Discovery setting makes it strict.
 * 32 pieces have both words in their title, type or tags, and they were scattered
 * through the six pages.
 *
 * WHAT IT DOES. Reads every results page, keeps Shopify's order, moves the pieces
 * whose own words contain every typed word to the front, and inside each of the two
 * groups puts the pieces whose product TYPE holds the typed words first (so "ring"
 * shows rings before bands titled "Band Ring"), then shows this page's slice of that list. The count line is Shopify's number and is not touched.
 *
 * WHERE THE WORDS COME FROM. snippets/gl-cards.liquid writes each card's title,
 * product type and tags into `data-w`, on /search only. Words match WHOLE, so
 * "ring" does not match "earring"; a trailing s is dropped on both sides, so
 * "rings" finds "Ring". "emerald ring" matches emerald-CUT pieces too, because the
 * word is in their title. That is what the words say, and the description is not
 * read at all, which is what keeps "emerald-cut diamond" in a description out.
 *
 * WHAT IT LEAVES ALONE. A sort the shopper chose (anything but relevance). A
 * search of more than ten pages. A search where every result, or none, matches.
 * Any page it cannot read within eight seconds: then nothing moves at all, so a
 * half-read list never reorders a page. Without this file the results are simply
 * in Shopify's order.
 */
(function () {
  'use strict';

  var grid = document.querySelector('ul.grid[data-rank-sid]');
  if (!grid || !('fetch' in window) || !('DOMParser' in window)) return;

  var params = new URLSearchParams(window.location.search);
  var q = (params.get('q') || '').trim();
  var sort = params.get('sort_by');
  if (!q || (sort && sort !== 'relevance')) return;

  function stem(w) { return (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) ? w.slice(0, -1) : w; }
  function words(s) { return (s.toLowerCase().match(/[a-z0-9À-ɏ]+/g) || []).map(stem); }

  var want = words(q).filter(function (w) { return w.length > 1; });
  if (!want.length) return;

  function hit(li) {
    var have = {};
    words(li.getAttribute('data-w') || '').forEach(function (w) { have[w] = true; });
    return want.every(function (w) { return have[w]; });
  }
  // The product TYPE words ("Solitaire Rings", "Hoop Earrings", "Bands"), written by snippets/gl-cards.liquid. How
  // many of the typed words are in a card's type decides the order inside each group (11 Oct 2026, round-2 audit:
  // "ring" opened on plain bands whose title says "Band Ring", ahead of the rings).
  function typeCount(li) {
    var have = {};
    words(li.getAttribute('data-t') || '').forEach(function (w) { have[w] = true; });
    return want.filter(function (w) { return have[w]; }).length;
  }
  function cardsIn(root) {
    var g = root.querySelector('ul.grid[data-rank-sid]');
    return g ? Array.prototype.slice.call(g.children).filter(function (el) { return el.classList.contains('card'); }) : null;
  }

  var page = parseInt(grid.getAttribute('data-page'), 10) || 1;
  var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1;
  var size = parseInt(grid.getAttribute('data-size'), 10) || 50;
  var sid = grid.getAttribute('data-rank-sid');
  if (pages > 20) return;   // was 10; "ring" has 12 pages of results (574 pieces) and was never reordered (11 Oct 2026)

  function place(all) {
    var scored = all.map(function (li, i) { return { li: li, i: i, h: hit(li) ? 0 : 1, t: typeCount(li) }; });
    scored.sort(function (a, b) { return a.h - b.h || b.t - a.t || a.i - b.i; });
    var ordered = scored.map(function (s) { return s.li; });
    var moved = ordered.some(function (li, k) { return li !== all[k]; });
    if (!moved) return;
    var mine = ordered.slice((page - 1) * size, page * size);
    // The cards ripple in once (site.css, "SEARCH RIPPLE"); taking them out and putting them back would play it again.
    grid.setAttribute('data-rip-off', '');
    cardsIn(document).forEach(function (li) { li.remove(); });
    var pager = grid.querySelector(':scope > :not(.card)');
    mine.forEach(function (li) {
      var node = li.ownerDocument === document ? li : document.importNode(li, true);
      grid.insertBefore(node, pager);
    });
  }

  if (pages === 1) { place(cardsIn(document) || []); return; }

  var ctrl = ('AbortController' in window) ? new AbortController() : null;
  var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
  var parser = new DOMParser();
  var jobs = [];
  for (var k = 1; k <= pages; k++) {
    if (k === page) { jobs.push(Promise.resolve(cardsIn(document))); continue; }
    var p = new URLSearchParams(params.toString());
    p.set('page', k); p.set('section_id', sid);
    jobs.push(fetch(window.location.pathname + '?' + p.toString(), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
      .then(function (html) { return cardsIn(parser.parseFromString(html, 'text/html')); }));
  }
  Promise.all(jobs).then(function (lists) {
    clearTimeout(timer);
    if (lists.some(function (l) { return !l; })) return;
    place([].concat.apply([], lists));
  }).catch(function () { clearTimeout(timer); });
})();
